import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import addUrlDefaultProtocol from '../../utils/addUrlDefaultProtocol';

export default class LinkButton extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    linkTarget: PropTypes.string.isRequired,
    enableHyperlink: PropTypes.bool.isRequired
  }

  static defaultProps ={
    linkTarget: '_self',
    enableHyperlink: true
  }

  render() {
    const { text, url, linkTarget, enableHyperlink } = this.props;
    return (
      <div {...resolve(this.props, 'container')} {...resolveTestId(this.props)}>
        <div {...resolve(this.props, 'buttonContainer')} >
          <a
            href={ enableHyperlink ? addUrlDefaultProtocol(url) : undefined }
            target={linkTarget}
            {...resolve(this.props, 'button')}
          >
            { text }
          </a>
        </div>
      </div>
    );
  }
}
